import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Access',
  attributeName: 'sourceFilesFormGroup',  
  fields: [
    {
      attributeName: 'status',
      label: 'Status',
      helpText: 'Status of Origin Access job.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'log',
      // width: '10rem',
      exactWidth:'200px',
      colors: {
        accessible: 'bg-success',
        unchecked: 'bg-info',
        inaccessible: 'bg-danger',
      },
    },
    {
      attributeName: 'refresh',
      label: 'Refresh',
      type: FormInputTypes.BUTTON_FORM,
      mode:'button',
      actionUrl: 'origin/refresh',
    },
    
  ],
};
